import React from 'react'
import styled from 'styled-components'
import pgLogo from '../images/pyramidgames.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons'
import Modal from '../components/modal'

const Container = styled.div`
  position: fixed;
  top: ${props => props.topBarOffset ? '26px' : '0'};
  width: 100%;
  height: 55px;
  background-color: ${props => props.theme.navBg};
  border-bottom: 2px solid #3e3e3e;
  display: flex;
`

const LogoHolder = styled.div`
  flex: 1;
  
  img {
    max-height: 35px;
    margin: 10px 15px;
  }
`

const TitleHolder = styled.div`
  flex: 1;
  text-align: center;
  line-height: 55px;
  font-weight: bold;
  font-size: 1.2rem;
  color: ${props => props.theme.navFg};

  @media (max-width: 700px) {
    display: none;
  }
`

const ButtonHolder = styled.div`
  flex: 1;
  text-align: right;
`

const NavButton = styled.a`
  display: inline-block;
  background-color: ${props => props.theme.buttonBg};
  margin: 12px 6px;
  padding: 0 10px;
  border-radius: 4px;
  color: ${props => props.theme.buttonFg};
  font-size: 0.9rem;
  text-decoration: none;
  text-align: center;
  min-width: 36px;
  height: 36px;
  line-height: 36px;
  cursor: pointer;
    
  span {
    margin-left: 6px;
  }

  @media (max-width: 1000px) {
    span {
      display: none;
    }
  }
`

const NavBar = ({config}) => {
    const [modalVisible, setModalVisible] = React.useState(false)
    return(
        <>
            <Container topBarOffset={config.project.topBar != null}>
                <LogoHolder>
                    <a href={'https://pyramid.games'} target='_blank' rel='noreferrer'>
                        <img src={pgLogo} alt={'Pyramid Games'}/>
                    </a>
                </LogoHolder>
                <TitleHolder>{config.project.name}</TitleHolder>
                <ButtonHolder>
                    <NavButton onClick={() => setModalVisible(true)}>
                        <FontAwesomeIcon icon={faInfoCircle}/>
                        <span>About the game</span>
                    </NavButton>
                </ButtonHolder>
            </Container>
            {
                modalVisible
                &&
                <Modal onClose={() => setModalVisible(false)}
                       title={config.project.name}
                       text={config.project.description} links={config.project.links}/>
            }
        </>
    )
}

export default NavBar
